import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const footerLinks = [
  { label: 'Priser', path: '/pricing' },
  { label: 'Så fungerar det', path: '/how-it-works' },
  { label: 'Integritet', path: '/privacy' },
  { label: 'Om oss', path: '/about' },
  { label: 'Villkor', path: '/terms' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        {/* Navigation Links */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: { xs: 2, sm: 3 },
            flexWrap: 'wrap',
            mb: 2,
          }}
        >
          {footerLinks.map((link, index) => (
            <MuiLink
              key={link.path}
              component={Link}
              to={link.path}
              sx={{
                color: '#1565C0',
                textDecoration: 'none',
                fontSize: '0.875rem',
                fontWeight: 500,
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {link.label}
            </MuiLink>
          ))}
        </Box>

        {/* Copyright */}
        <Typography
          variant="body2"
          sx={{
            color: '#666',
            textAlign: 'center',
            fontSize: '0.8rem',
          }}
        >
          © {currentYear} Seglingssajten. Alla rättigheter förbehållna.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
